import * as types from './types';

export const getUsersList = (queryParams) => ({
  type: types.ADMIN_USERS_GET_LIST,
  queryParams
});

export const setUsersList = (users) => ({
  type: types.ADMIN_USERS_SET_LIST,
  users
});

export const setUsersListLoading = (isLoading) => ({
  type: types.ADMIN_USERS_SET_LIST_LOADING,
  isLoading
});

export const resetUsersList = () => ({
  type: types.ADMIN_USERS_RESET_LIST
});

export const setAddingNewAdmin = (adding) => ({
  type: types.ADMIN_USERS_SET_ADDING_NEW_ADMIN,
  adding
});

export const addNewAdmin = (newAdmin) => ({
  type: types.ADMIN_USERS_ADD_NEW_ADMIN,
  newAdmin
});

export const setNewAdminErrors = (errors = null) => ({
  type: types.ADMIN_USERS_SET_NEW_ADMIN_ERRORS,
  errors
});

export const setEditingAdminProfile = (editing) => ({
  type: types.ADMIN_USERS_SET_EDITING_ADMIN_PROFILE,
  editing
});

export const editAdminProfile = (profileData, userId) => ({
  type: types.ADMIN_USERS_EDIT_ADMIN_PROFILE,
  profileData,
  userId
});

export const setQueryParams  = (queryParams) => ({
  type: types.ADMIN_USERS_SET_QUERY_PARAMS,
  queryParams
});

export const setUserStatusUpdating = (isUpdating) => ({
  type: types.ADMIN_USERS_SET_USER_STATUS_UPDATING,
  isUpdating
});

export const enableUser = (userId) => ({
  type: types.ADMIN_USERS_ENABLE_USER,
  userId
});

export const disableUser = (userId) => ({
  type: types.ADMIN_USERS_DISABLE_USER,
  userId
});


// WEBPACK FOOTER //
// ./src/actions/admin/users/index.js